import { render, staticRenderFns } from "./TextoBotao.vue?vue&type=template&id=bf1e2324"
import script from "./TextoBotao.vue?vue&type=script&lang=js"
export * from "./TextoBotao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports